module.exports = __webpack_public_path__ + "img/21.b3f3e99e.png";